import { render, staticRenderFns } from "./paperDelivery.html?vue&type=template&id=3cfeca0f&"
import script from "./paperDelivery.js?vue&type=script&lang=js&"
export * from "./paperDelivery.js?vue&type=script&lang=js&"
import style0 from "./paperDelivery.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports